'use strict';

class CollapsibleRow extends HTMLElement {
    constructor() {
        super()

        this.collapsibleBtn = this.querySelector('.collapsibleBtn') 
        this.collapsibleContent = this.querySelector('.collapsibleContent')
        this.collapsibleArrow = this.querySelector('.collapsibleArrow')

        this.collapsibleBtn.addEventListener('click', this.toggleContentRow.bind(this))

    }

    toggleContentRow() {
        this.collapsibleContent.classList.toggle('displayNone')
        this.collapsibleArrow.classList.toggle('flipV')
    }

}
customElements.define('collapsible-row', CollapsibleRow)


class SliderBasic extends HTMLElement {
    constructor() {
        super()

        // Elements
        this.slideImageWraps = this.querySelectorAll('.slideImageWrap')
        this.slideDots = this.querySelectorAll('.slideDot')
        this.slideButtonPrev = this.querySelector('.slideButtonPrev')
        this.slideButtonNext = this.querySelector('.slideButtonNext')
        this.progressBar = this.querySelector('.progressBar')
        this.contentContainers = this.querySelectorAll('.contentContainer')

        // Script settings
        this.slideTime = this.querySelector('script[data-slide-time]').dataset.slideTime * 1000
        this.autoPlay = this.querySelector('script[data-auto-play]').dataset.autoPlay == 'true'
        this.transitionEffect = this.querySelector('script[data-transition-effect]').dataset.transitionEffect
        this.transitionTime = parseInt(this.querySelector('script[data-transition-time]').dataset.transitionTime, 10)

        // Init variables / function scoping
        this.intervalFunc
        this.animProgFunc

        this.numberOfSlidesIndexes = this.slideImageWraps.length - 1
        this.currentIndex = 0
        this.lastIndex = 0
        this.isPaused = false

        // Add event listeners
        this.slideButtonPrev.addEventListener('click', this.prevSlide.bind(this))
        this.slideButtonNext.addEventListener('click', this.nextSlide.bind(this))
        this.slideDots.forEach(dot => dot.addEventListener('click', this.changeByDot.bind(this)))
        this.slideImageWraps.forEach(slide => slide.addEventListener('click', this.sliderState.bind(this)))
        
        if(this.autoPlay) {
            this.play()
        }
    }


    prevSlide() {
        if(this.currentIndex - 1 >= 0) {
            this.currentIndex --
        } else {
            this.currentIndex = this.numberOfSlidesIndexes
        }
        this.updateDot()
        this.changeSlide()
        this.resetTimer()
    }

    nextSlide(e) {
        if(this.currentIndex + 1 <= this.numberOfSlidesIndexes) {
            this.currentIndex ++
        } else {
            this.currentIndex = 0
        }
        this.updateDot()
        this.changeSlide()
        if(e) { this.resetTimer() }
    }

    changeSlide() {
        this.slideImageWraps[this.lastIndex].classList.add('displayNone')
        this.slideImageWraps[this.currentIndex].classList.remove('displayNone')
        if(this.contentContainers[this.lastIndex]) {
            this.contentContainers[this.lastIndex].classList.add('displayNone')
        }
        if(this.contentContainers[this.currentIndex]) {
            this.contentContainers[this.currentIndex].classList.remove('displayNone')
        }
        this.lastIndex = this.currentIndex
        this.animateSliderImage()
    }

    changeByDot(e) {
        this.currentIndex = parseInt(e.currentTarget.dataset.index, 10) 
        this.updateDot()
        this.changeSlide()
        this.resetTimer()
    }

    updateDot() {
        this.slideDots[this.lastIndex].classList.remove('slideDotSelected')
        this.slideDots[this.lastIndex].classList.remove('slideDotSelectedPause')
        if(this.isPaused) {
            this.slideDots[this.currentIndex].classList.add('slideDotSelectedPause')
        } else {
            this.slideDots[this.currentIndex].classList.add('slideDotSelected')
        }
    }

    play() {
        this.intervalFunc = setInterval(() => {
            this.nextSlide()
        }, this.slideTime);
        this.isPaused = false
        this.progressBarAnim()
        this.updateDot()
    }

    pause() {
        clearInterval(this.intervalFunc)
        this.animProgFunc.cancel()
        this.isPaused = true
        this.slideDots[this.currentIndex].classList.add('slideDotSelectedPause')
    }

    sliderState() {
        if (!this.autoPlay) { return }
        this.isPaused ? this.play() : this.pause()
    } 


    resetTimer() {
        if(!this.autoPlay) { return }
        clearInterval(this.intervalFunc)
        this.animProgFunc.cancel()
        if(!this.isPaused) {
            this.play()
        }
    }

    progressBarAnim() {
        if(!this.progressBar) { return }
        let barType = this.progressBar.dataset.type
        let anim
        if(barType == 'vertical') {
            anim = [{height: '100%'}]
        } else if (barType == 'horizontal') {
            anim = [{width: '100%'}]
        }
        this.animProgFunc = this.progressBar.querySelector('div').animate(anim, {duration: this.slideTime, iterations: Infinity}) 
    }

    animateSliderImage() {
        const transitionEffectsList = {
            blur: [
                {filter: "blur(5px)"},
                {filter: "blur(0)"}
            ],
            grayscale: [
                {filter: "grayscale(1)"},
                {filter: "grayscale(0)"}            
            ],
            brightness: [
                {filter: "brightness(0.2)"},
                {filter: "brightness(1)"}  
            ]
        }

        this.slideImageWraps[this.lastIndex].animate(transitionEffectsList[this.transitionEffect], {duration: this.transitionTime, fill: 'none'})
    }

} 
customElements.define('slider-basic', SliderBasic)


class ProductRecommendations extends HTMLElement {
    constructor() {
        super()

        this.productId = this.querySelector('script[data-product-id]').dataset.productId 
        this.intent = this.querySelector('script[data-intent]').dataset.intent
        this.limit = parseInt(this.querySelector('script[data-limit]').dataset.limit, 10)
        this.sectionId = this.querySelector('script[data-section-id]').dataset.sectionId
        this.productRecContainer = this.querySelector('.productRecContainer')

        this.request()        
    }

    async request() {
        let req = await fetch (`${window.Shopify.routes.root}recommendations/products?product_id=${this.productId}&limit=${this.limit}&intent=${this.intent}&section_id=${this.sectionId}`)
        if(req.ok) {
            let res = await req.text()
            let dom = new DOMParser().parseFromString(res, 'text/html')
            console.log(dom)
            this.productRecContainer.replaceWith(dom.querySelector('.productRecContainer'))

            const slideshow = this.querySelector('custom-slideshow') 
            if(slideshow.shouldSetup) {
                slideshow.initSetup(undefined)
            }
        }
    }
}
customElements.define('product-recommendations', ProductRecommendations)


if(Shopify.designMode) {
    document.addEventListener('shopify:block:select', (e) => {
        // Pause sliders on block/slide select inside editor

        let sliderSection = e.target.closest('slider-basic')
        if(sliderSection) {
            let slideId = parseInt(e.target.dataset.slidePosition, 10)
            sliderSection.currentIndex = slideId
            sliderSection.updateDot()
            sliderSection.changeSlide()
            sliderSection.pause()
        }

    })
}

class CustomSlideshow extends HTMLElement {
    constructor(data) {
        super()

        if(data != undefined) {
            this.shouldSetup = data.setup === 'true' ? true : false 
        } else {
            this.shouldSetup = this.dataset.setup === 'true' ? true : false 
        }

        if(!this.shouldSetup) {
            return
        }
        this.initSetup(data)

    }

    initSetup(data) {

        if(data != undefined) {
            this.slideElements = data.elements
            this.colDesk = parseInt(data.colDesktop, 10)
            this.colMobile =  parseInt(data.colMobile, 10) 
        } else {
            this.slideElements = this.querySelectorAll('.slideElement')
            this.colMobile =  parseInt(this.dataset.colMobile, 10)
            this.colDesk = parseInt(this.dataset.colDesktop, 10)
        }

        this.activeCol 
        this.time
        this.currentWidth = null


        this.wrapControls = document.createElement('div')
        this.wrapControls.classList.add('slideshowControlsWrap')
        
        this.dotsWrap = document.createElement('div')
        this.dotsWrap.classList.add('slideShowDotsWrap')
        this.buttonsWrap = document.createElement('div')
        this.buttonsWrap.classList.add('slideShowButtonWrap', 'containerCorners')

        this.leftBtn = document.createElement('button')
        this.leftBtn.classList.add('navElement', 'slideShowControlBtn')
        this.leftBtn.setAttribute('aria-label', window.accessibilityStrings.previous_slide)
        this.leftBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg>'

        this.rightBtn = document.createElement('button')
        this.rightBtn.setAttribute('aria-label', window.accessibilityStrings.next_slide)
        this.rightBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg>'
        this.rightBtn.classList.add('navElement', 'slideShowControlBtn')

        this.setup()


        this.leftBtn.addEventListener('click', this.change.bind(this, 'prev'))
        this.rightBtn.addEventListener('click', this.change.bind(this, 'next'))
    
        this.buttonsWrap.append(this.leftBtn, this.dotsWrap, this.rightBtn)
        this.wrapControls.append(this.buttonsWrap)
        this.append(this.wrapControls)

        window.addEventListener('resize', this.setupDeb.bind(this))

    }

    change(action) {
        if(action == 'prev' && this.currentSlide > 1) {
            this.pos -= this.activeCol
            this.currentSlide --
        } else if (action == 'next' && this.currentSlide < this.slides) {
            this.pos += this.activeCol
            this.currentSlide ++
        } else {
            return
        }

        const activeSlides = this.querySelectorAll('.slideElement:not(.displayNone)')
        if(activeSlides) {
            activeSlides.forEach(el => el.classList.add('displayNone'))
        }

        this.querySelector('.slideshowDotActive').classList.remove('slideshowDotActive')
        this.slideDots[this.currentSlide - 1].classList.add('slideshowDotActive')

        let spacesToFill = 0
        for(let i = this.pos; i < this.pos + this.activeCol; i ++) {
            if(this.slideElements[i]) {
                this.slideElements[i].classList.remove('displayNone')
                this.slideElements[i].animate([{filter: 'blur(2px) grayscale(1)'}, {filter: 'blur(0) grayscale(0)'}], {duration: 500})
            } else {
                spacesToFill ++
            }
        }

        if(spacesToFill > 0) {
            for(let i = 0; i < spacesToFill; i++) {                
                this.slideElements[((this.slideElements.length) - (this.activeCol - spacesToFill)) - i - 1].classList.remove('displayNone')
            }
        }
    }

    setup() {

        if(window.innerWidth > 1080 && this.currentWidth == 'desktop') {
            return
        } 
        
        if (window.innerWidth <= 1080 && this.currentWidth == 'mobile') {
            return
        }

        if(window.innerWidth > 1080) {
            this.currentWidth = 'desktop'
        } else {
            this.currentWidth = 'mobile'
        }

        this.slideElements.forEach(el => {
            el.classList.add('displayNone')
        })

        this.dotsWrap.innerHTML = ''

        if(window.innerWidth <= '1080' ) {
            this.activeCol = this.colMobile
        } else {
            this.activeCol = this.colDesk
        }

        for(let i = 0; i < this.activeCol; i++) {
            if(this.slideElements[i]) {
                this.slideElements[i].classList.remove('displayNone')
            }
        }

        this.slides = Math.ceil(this.slideElements.length / this.activeCol)

        if(this.slideElements.length <= this.activeCol) {
            this.wrapControls.classList.add('displayNone')
        } else {

            this.slideDots = []
            for(let i = 0; i < this.slides; i++) {
                const slideDot = document.createElement('div')
                slideDot.classList.add('slideshowDot')
                this.dotsWrap.append(slideDot)
                if(i == 0) {
                    slideDot.classList.add('slideshowDotActive')
                }
                this.slideDots.push(slideDot)
            }
    
            this.pos = 0
            this.currentSlide = 1

            this.wrapControls.classList.remove('displayNone')
        }


    }

    setupDeb() {
        clearTimeout(this.time)
        this.time = setTimeout(() => {
            return this.setup()
        }, 500);
    }
}
customElements.define('custom-slideshow', CustomSlideshow)


class CountdownTimer extends HTMLElement {
    constructor() {
        super()

        this.time = {
            "d": this.querySelector('.d'),
            "h": this.querySelector('.h'),
            "m": this.querySelector('.m'),
            "s": this.querySelector('.s')
        }

        this.endsOn = this.dataset.date
        this.hide = this.dataset.hide == 'true' ? true : false

        this.dateTime = this.endsOn.split(' ')

        this.dateFuture

        const count = setInterval(() => {

            const dateNow = new Date().getTime()

            var distance = this.dateFuture - dateNow;


            var day = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hour = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var min = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var sec = Math.floor((distance % (1000 * 60)) / 1000);

            this.time.d.innerText = day
            this.time.h.innerText = hour
            this.time.m.innerText = min
            this.time.s.innerText = sec

            if(distance <= 0) {
                clearTimeout(count)
                if(this.hide) {
                    this.closest('section').classList.add('displayNone')
                }

                this.time.d.innerText = '00'
                this.time.h.innerText = '00'
                this.time.m.innerText = '00'
                this.time.s.innerText = '00'
            }

        }, 1000);
    }

    connectedCallback() {
        const year = this.dateTime[0].split('-')[0]
        const month = this.dateTime[0].split('-')[1]
        const day = this.dateTime[0].split('-')[2]
        const hour = this.dateTime[1].split(':')[0]
        const min = this.dateTime[1].split(':')[1]
        
        this.dateFuture = new Date(year, month - 1, day, hour, min);
    }
}
customElements.define('countdown-timer', CountdownTimer)